function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ElementModel } from './ElementModel';
import * as Y from 'yjs';
import { chunk } from 'lodash';
import { getStroke } from 'perfect-freehand';
import { EditorConfig } from '../../edit/EditorConfig';
export class EraserModel extends ElementModel {
  get drawPoints() {
    if (this.localPoints.length > 0) {
      return this.localPoints;
    }
    return this.points;
  }
  constructor(root, scope, liveCursor, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "sliceBegin", 0);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", false);
    _defineProperty(this, "shouldUseLocalPoints", true);
    _defineProperty(this, "localPointsPick", 4);
    if (this.root.doc && !this.root.has('type')) {
      this.root.set('type', 'eraser');
    }
    if (this.root.doc && !this.root.has('points')) {
      this.root.set('points', new Y.Array());
    }
  }
  average(a, b) {
    return (a + b) / 2;
  }
  createPath(points) {
    const path = new this.scope.Path();
    const len = points.length;
    if (len < 4) {
      return path;
    }
    let control = new this.scope.Point(0, 0);
    let current = new this.scope.Point(0, 0);
    let a = points[0];
    let b = points[1];
    const c = points[2];
    current = new this.scope.Point(a[0], a[1]);
    path.moveTo(current);
    control = new this.scope.Point(b[0], b[1]);
    current = new this.scope.Point(this.average(b[0], c[0]), this.average(b[1], c[1]));
    path.quadraticCurveTo(control, current);
    for (let i = 2, max = len - 1; i < max; i++) {
      a = points[i];
      b = points[i + 1];
      control = current.multiply(2).subtract(control);
      current = new this.scope.Point(this.average(a[0], b[0]), this.average(a[1], b[1]));
      path.quadraticCurveTo(control, current);
    }
    return path;
  }
  parsePoints(points) {
    const groupPoints = chunk(points, 2);
    return getStroke(groupPoints, {
      size: this.strokeWidth,
      smoothing: 0.5,
      thinning: -0.5,
      streamline: 0.5,
      simulatePressure: true,
      start: {
        taper: this.strokeWidth * 10,
        cap: true
      },
      end: {
        taper: this.strokeWidth * 20,
        cap: true
      }
    });
  }
  matrixedPoints() {
    const currentPoints = chunk(this.drawPoints, 2).slice(this.sliceBegin);
    return currentPoints.map(_ref => {
      let [x, y] = _ref;
      return new this.scope.Point(x, y);
    }).map(p => p.transform(new this.scope.Matrix(this.pointsMatrix))).reduce((result, next) => {
      result.push(next.x);
      result.push(next.y);
      return result;
    }, []);
  }
  onVectorUpdate() {
    if (!this.item) {
      return;
    }
    const points = this.parsePoints(this.matrixedPoints());
    const path = this.createPath(points);
    this.item.removeSegments();
    this.item.addSegments(path.segments);
  }
  createPaperItem() {
    this.item = new this.scope.Path();
    this.item.strokeCap = 'round';
    this.item.strokeJoin = 'round';
    this.item.strokeScaling = false;
    this.item.strokeColor = new this.scope.Color(this.strokeColor);
    this.item.fillColor = new this.scope.Color(this.strokeColor);
    this.onVectorUpdate();
    this.item.onFrame = () => {
      if (!this.drawPoints) {
        return;
      }
      if (this.drawPoints.length / 2 > 50) {
        this.sliceBegin = this.drawPoints.length / 2 - 50;
      }
    };
  }
  editorConfig() {
    return new EditorConfig();
  }
  vectorKeys() {
    return [];
  }
  styleKeys() {
    return {
      include: [],
      exclude: []
    };
  }
  onStyleKeyUpdate(_key) {
    return;
  }
  subDispose() {}
  liveCursorPoint() {
    const yArray = this.root.get(ElementModel.KEYS.points);
    if (yArray.length < 2) {
      return null;
    }
    const len = yArray.length;
    const point = new this.scope.Point(yArray.get(len - 2), yArray.get(len - 1));
    return point.transform(new this.scope.Matrix(this.pointsMatrix));
  }
}